import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Copy } from 'lucide-react'
import ModalContainer from "../../../2d-game/modals/ModalContainer";
import { SelectTitliReprintList } from '../../../redux/titli-slice/gameInfoTitliSlice'
import { SocketState } from '../../../context/SocketProvider'
import { SET_MAIN_LOADER } from '../../../redux/loaderSlice'
import { AuthState } from "../../../context/AuthProvider";

function ReprintLIst() {
  const dispatch = useDispatch()
  const { socket } = SocketState()
  const { userDetail } = AuthState()
  let PrintList = useSelector(SelectTitliReprintList)

  // Local state for popup preview
  const [previewTicket, setPreviewTicket] = useState(null)
  const [copiedTicket, setCopiedTicket] = useState(null)

  const handleViewTicket = (ticket_id) => {
    dispatch(SET_MAIN_LOADER(true));

    socket.emit("req", {
      en: "GET_ADVANCE_BETS_LISTS",
      data: {
        ticket_id,
      },
    });
  };

  useEffect(() => {
    if (!socket) return;

    const handleResponse = (response) => {
      console.log('Socket Response', response);

      if (response?.en === 'GET_ADVANCE_BETS_LISTS') {
        dispatch(SET_MAIN_LOADER(false));
        setPreviewTicket(response.data);
      }
    };

    socket.on('res', handleResponse);

    return () => {
      socket.off('res', handleResponse);
    };
  }, [socket]);

  let reprintSubmit = (ticket_id) => {
    dispatch(SET_MAIN_LOADER(true))
    socket.emit('req', {
      "en": "LUCKY_SORAT_PRINT_TICKETS",
      "data": { ticket_id }
    })
    setPreviewTicket(null) // Close preview popup after sending
  }

  const animalImages = {
    "Ball": '../../../images/football111.gif',
    "Kite": '../../../images/kitework123.gif',
    "Cow": '../../../images/cat1212.gif',
    "Gariyo": '../../../images/horse1.gif',
    "Amrela": '../../../images/umbrela11.gif',
    "WatterDoll": '../../../images/bullet121.gif',
    "Butterfly": '../../../images/butterfly2121.gif',
    "Rose": '../../../images/rose132.gif',
    "Sun": '../../../images/tiger11.gif',
    "Lamp": '../../../images/dipak1231.gif',
    "Egle": '../../../images/kabutar123.gif',
    "Rebit": '../../../images/rabit132.gif'
  };

  const renderStatus = (status) => {
    if (status === 0) {
      return <span className="p-3 rounded-full text-sm font-semibold bg-yellow-100 text-yellow-800">Not Result Declare</span>;
    }
    if (status === 1) {
      return <span className="p-3 rounded-full text-sm font-semibold bg-blue-100 text-blue-800">Cancelled</span>;
    }
    if (status === 2) {
      return <span className="p-3 rounded-full text-sm font-semibold bg-indigo-100 text-indigo-800">Not Claim</span>;
    }
    if (status === 3) {
      return <span className="p-3 rounded-full text-sm font-semibold bg-green-100 text-green-800">Claimed</span>;
    }
    if (status === 4) {
      return <span className="p-3 rounded-full text-sm font-semibold bg-red-100 text-red-800">Loss</span>;
    }

    return <span className="p-3 rounded-full text-sm font-semibold bg-gray-100 text-gray-700">Unknown</span>;
  };

  // 👇 Copy Ticket ID
  const handleCopy = async (ticket_id) => {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(ticket_id)
        setCopiedTicket(ticket_id)
        setTimeout(() => setCopiedTicket(null), 1000)
      } catch (err) {
        console.error('Clipboard write failed:', err)
        alert('Failed to copy ticket ID')
      }
    } else {
      // Fallback for unsupported browsers
      const tempInput = document.createElement('input')
      tempInput.value = ticket_id
      document.body.appendChild(tempInput)
      tempInput.select()
      document.execCommand('copy')
      document.body.removeChild(tempInput)
      setCopiedTicket(ticket_id)
      setTimeout(() => setCopiedTicket(null), 1000)
    }
  }


  return (
    <ModalContainer title={'RePrint'} navigation={'/titli'}>

      {/* No data */}
      {!PrintList.length &&
        <div className='flex w-[90%] mx-auto flex-wrap h-[calc(100vh-20vh)] overflow-y-auto'>
          <div className='flex justify-center w-full pt-10'>
            <p className='text-center font-bold text-[18px]'>No Data Found</p>
          </div>
        </div>
      }

      {/* List */}
      {PrintList.length > 0 &&
        <div className='mt-5'>
          <div className='w-full border-b rounded border-gray-200 py-3.5 mb-2 bg-[#bdbaba] text-black flex px-3'>
            <div className='w-1/5 text-center font-semibold text-[17px]'>Date</div>
            <div className='w-1/5 text-center font-semibold text-[17px]'>Time</div>
            <div className='w-1/5 text-center font-semibold text-[17px]'>Ticket ID</div>
            <div className='w-1/5 text-center font-semibold text-[17px]'>Bet Amount</div>
            <div className='w-1/5 text-center font-semibold text-[17px]'>Status</div>
            <div className='w-1/5 text-center font-semibold text-[17px]'>Win</div>
            <div className='w-1/5 text-center font-semibold text-[17px]'></div>
          </div>

          <div className='h-[calc(100vh-32vh)] overflow-y-auto'>
            {PrintList.map((list, index) => {
              return (
                <div className='w-full border-b border-gray-200 py-3.5 mb-2 bg-white flex px-3' key={index}>
                  <div className='w-1/5 text-center font-semibold text-[17px]'>{list.deal_date}</div>
                  <div className='w-1/5 text-center font-semibold text-[17px]'>{list.deal_time}</div>

                  {/* ✅ Ticket ID with Copy icon */}
                  <div className='w-1/5 text-center font-semibold text-[17px] flex items-center justify-center gap-2'>
                    <span>{list.ticket_id}</span>
                    <button
                      onClick={() => handleCopy(list.ticket_id)}
                      className='text-gray-500 hover:text-blue-600 transition-all'
                      title='Copy Ticket ID'
                    >
                      <Copy size={18} />
                    </button>
                    {copiedTicket === list.ticket_id && (
                      <span className='text-green-500 text-sm animate-pulse'>Copied!</span>
                    )}
                  </div>

                  <div className='w-1/5 text-center font-semibold text-[17px]'>{Math.floor(list.total_bet_amount)}</div>

                  <div className="w-1/5 text-center font-semibold text-[15px] flex justify-center">
                    {renderStatus(list.status)}
                  </div>

                  <div className="w-1/5 text-center font-semibold text-[15px] flex justify-center">
                    {list.total_win_amount ?? 0}
                  </div>

                  <div className='w-1/5 text-center font-semibold text-[17px]'>
                    <button
                      className="bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-1/2"
                      type="button"
                      onClick={() => {
                        handleViewTicket(list.ticket_id);
                      }} // 👈 show preview
                    >
                      {userDetail?.print ? "Print" : "View"}
                    </button>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      }


      {previewTicket && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50 text-[12px] font-mono">


          <table className="w-full border-collapse mb-4">
            <thead>
              <tr>
                <td colSpan={4}>
                  <div
                    className="font-mono"
                    style={{
                      width: "300px",
                      margin: "auto",
                      background: "#f5f5f5",
                      padding: "15px",
                      color: "#000",
                      borderRadius: "5px",
                    }}
                  >
                    <h4 style={{ margin: 0, fontWeight: "bold" }}>
                      {previewTicket.game_name || "Titli"}
                    </h4>

                    <div className="text-[12px]">
                      <i>
                        Amusement Only, {previewTicket.game_name || "Titli"} Game
                      </i>
                    </div>

                    <div className="text-[12px]">
                      <b>Game Date:</b> {previewTicket.deal_date}
                    </div>

                    <div className="text-[12px]">
                      <b>Game Time:</b> {previewTicket.deal_time}
                    </div>

                    <div className="text-[12px]">
                      <b>Game ID:</b> {previewTicket.ticket_id}
                    </div>

                    <div className="text-[12px] mb-2">
                      <b>Operator ID:</b> {userDetail?.user_name}
                    </div>


                    <div className="text-[12px]">
                      <b>Total Selected Spots:</b>{" "}
                      {Object.keys(previewTicket.card_details || {}).length}
                    </div>

                    <div className="text-[12px] mb-2">
                      <b>Total Point:</b>{" "}
                      {Math.floor(previewTicket.total_bet_amount)}
                    </div>


                    {Object.entries(previewTicket.card_details || {})
                      .reduce((rows, item, index) => {
                        if (index % 2 === 0) rows.push([]);
                        rows[rows.length - 1].push(item);
                        return rows;
                      }, [])
                      .map((row, rowIndex) => (
                        <div
                          key={rowIndex}
                          style={{
                            display: "flex",
                            marginBottom: "6px",
                          }}
                        >
                          {row.map(([number, amount]) => (
                            <div
                              key={number}
                              style={{
                                width: "50%",
                                fontSize: "14px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={animalImages[number]}
                                alt={number}
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  marginRight: "8px",
                                }}
                                onError={(e) => {
                                  e.target.style.display = "none";
                                }}
                              />

                              <span>* {amount}</span>
                            </div>
                          ))}
                        </div>
                      ))}

                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        marginTop: "8px",
                        fontSize: "18px",
                      }}
                    >
                      {previewTicket.ticket_id}
                    </div>
                    {previewTicket?.is_advance && (
                      <table className="w-full leading-none bordered font-mono">
                        <tbody>
                          {previewTicket.bets?.map((bet, index) => (
                            <tr key={index}>
                              <td className=" text-[12px] border px-1 py-1 text-center">
                                {bet.deal_time}
                              </td>
                              <td className=" text-[12px] border px-1 py-1 text-center">
                                {bet.ticket_id}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                    <div className="flex justify-end gap-3 mt-6">
                      <button
                        className="bg-gray-400 hover:bg-gray-500 text-white font-bold py-2 px-4 rounded"
                        onClick={() => setPreviewTicket(null)}
                      >
                        Cancel
                      </button>

                      {userDetail?.print ?
                        <button
                          className="bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded"
                          onClick={() => reprintSubmit(previewTicket.ticket_id)}
                        >
                          Print
                        </button>
                        : ''}

                    </div>
                  </div>

                </td>
              </tr>
            </thead>
          </table>


        </div>
      )}
      {/* Popup Preview Modal */}
      {/* {previewTicket && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white w-[800px] rounded-lg shadow-lg p-5">
            <h2 className="text-lg font-bold mb-4 text-center">Ticket Preview</h2>
            
            
            <table className="w-full border-collapse mb-4">
              <thead>
                <tr>
                  <td className="font-semibold border px-2 py-1">Date:</td>
                  <td className="border px-2 py-1">{previewTicket.deal_date}</td>
                  <td className="font-semibold border px-2 py-1">Time:</td>
                  <td className="border px-2 py-1">{previewTicket.deal_time}</td>
                </tr>
                <tr>
                  <td className="font-semibold border px-2 py-1">Ticket ID:</td>
                  <td className="border px-2 py-1">{previewTicket.ticket_id}</td>
                  <td className="font-semibold border px-2 py-1">Bet Amount:</td>
                  <td className="border px-2 py-1">{Math.floor(previewTicket.total_bet_amount)}</td>
                </tr>
                {!userDetail?.print && (<>
                  <tr>
                    <td
                      colSpan={4}
                      className="border px-2 py-2 text-center font-bold bg-gray-200"
                      style={{ fontSize: "16px" }}
                    >
                      Bet Details
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={4}>
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",  
                          background: "#f9f9f9",
                          padding: "4px"
                        }}
                      >
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            textAlign: "center",
                            border: "1px solid #ddd",
                            background: "#f9f9f9",
                          }}
                        >
                          {
                            // Chunking into rows of 20
                            Object.entries(previewTicket.card_details)
                              .reduce((rows, entry, idx) => {
                                if (idx % 6 === 0) rows.push([]);
                                rows[rows.length - 1].push(entry);
                                return rows;
                              }, [])
                              .map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {
                                    row.map(([number, amount], i) => (
                                      <td
                                        key={i}
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "600",
                                          padding: "0.2rem",
                                          borderBottom: "1px solid #ddd",
                                          lineHeight: "1rem",
                                          verticalAlign: "unset",
                                        }}
                                      >
                                        <img
                                          src={`${animalImages[number]}`}
                                          style={{
                                            width: '90px',
                                            height: '90px',
                                            marginBottom: '-2px',
                                          }}
                                          alt={number}
                                        />
                                        <br />
                                        <span
                                          style={{
                                            border: "1px solid #fff",
                                            padding: "2px 9px",
                                            color: "#000",
                                            background: "#d9ddff",
                                            borderRadius: "4px",
                                            display: "inline-block",
                                          }}
                                        >
                                          {amount}
                                        </span>
                                      </td>
                                    ))
                                  }
                                </tr>
                              ))
                          }
                        </table>
                      </div>
                    </td>
                  </tr></>
                )}
              </thead>
            </table>

            <div className="flex justify-end gap-3 mt-6">
              <button
                className="bg-gray-400 hover:bg-gray-500 text-white font-bold py-2 px-4 rounded"
                onClick={() => setPreviewTicket(null)}
              >
                Cancel
              </button>
              
              {userDetail?.print ? <button
                className="bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded"
                onClick={() => reprintSubmit(previewTicket.ticket_id)}
              >
                Print
              </button> : ""}
            </div>
          </div>
        </div>
      )} */}

    </ModalContainer>
  )
}

export default ReprintLIst